import { useTranslation } from "react-i18next";
import capitalize from "lodash/capitalize";
import { MOVEMENTS } from "../../../constants";
import ExtraInputComponent from "../../other-exercise/ExtraInputComponent";
import OtherExerciseFields from "../../other-exercise/OtherExerciseFields";

const AddLibraryExercise = ({
  basicExerciseType,
  handleChange,
  movementName,
  handleNewMovementChange,
  primary,
  videoUrl,
  videoFile,
  videoOriginal,
  exerciseTypeField,
  primaryMuscleGroup,
  secondaryMuscleGroup,
  instructions,
  handleNewFieldsInputChange,
  parameters,
  freeFormSelected,
  updateOtherExerciseParameters,
  intensityMeasure,
  isRiR,
  onDiscard,
  isSecondaryDisabled,
}) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  return (
    <>
      <div className="body">
        <div className="form-row">
          <div className="form-row-item">
            <label>{t("addExerciseModal.exerciseType")}</label>
            <div className="option-toggler">
              <label
                className={
                  basicExerciseType === "basicExercise" ? "active" : ""
                }
              >
                <input
                  type="radio"
                  name="basicExerciseType"
                  value="basicExercise"
                  checked={basicExerciseType === "basicExercise"}
                  onChange={handleChange}
                />
                <span>{t("addExerciseModal.accessory")}</span>
              </label>

              <label
                className={
                  basicExerciseType === "powerliftingExercise" ? "active" : ""
                }
              >
                <input
                  type="radio"
                  name="basicExerciseType"
                  value="powerliftingExercise"
                  checked={basicExerciseType === "powerliftingExercise"}
                  onChange={handleChange}
                />
                <span>{t("addExerciseModal.primaryVariation")}</span>
              </label>
            </div>
          </div>
        </div>

        {basicExerciseType === "basicExercise" && (
          <input type="hidden" name="primary" value="assistant" />
        )}
        {basicExerciseType === "powerliftingExercise" && (
          <>
            <div className="form-row">
              <div className="form-row-item">
                <label>{t("addExerciseModal.type")}</label>
                <div className="option-toggler">
                  <label className={primary === "squat" ? "active" : ""}>
                    <input
                      type="radio"
                      name="primary"
                      value="squat"
                      checked={primary === "squat"}
                      onChange={handleChange}
                    />
                    <span>{t("addExerciseModal.squat")}</span>
                  </label>

                  <label className={primary === "bench" ? "active" : ""}>
                    <input
                      type="radio"
                      name="primary"
                      value="bench"
                      checked={primary === "bench"}
                      onChange={handleChange}
                    />
                    <span>{t("addExerciseModal.bench")}</span>
                  </label>

                  <label className={primary === "deadlift" ? "active" : ""}>
                    <input
                      type="radio"
                      name="primary"
                      value="deadlift"
                      checked={primary === "deadlift"}
                      onChange={handleChange}
                    />
                    <span>{t("addExerciseModal.deadlift")}</span>
                  </label>

                  <label className={primary === "clean" ? "active" : ""}>
                    <input
                      type="radio"
                      name="primary"
                      value="clean"
                      checked={primary === "clean"}
                      onChange={handleChange}
                    />
                    <span>{t("addExerciseModal.clean")}</span>
                  </label>

                  <label className={primary === "jerk" ? "active" : ""}>
                    <input
                      type="radio"
                      name="primary"
                      value="jerk"
                      checked={primary === "jerk"}
                      onChange={handleChange}
                    />
                    <span>{t("addExerciseModal.jerk")}</span>
                  </label>

                  <label className={primary === "snatch" ? "active" : ""}>
                    <input
                      type="radio"
                      name="primary"
                      value="snatch"
                      checked={primary === "snatch"}
                      onChange={handleChange}
                    />
                    <span>{t("addExerciseModal.snatch")}</span>
                  </label>

                  <label
                    className={primary === "overheadPress" ? "active" : ""}
                  >
                    <input
                      type="radio"
                      name="primary"
                      value="overheadPress"
                      checked={primary === "overheadPress"}
                      onChange={handleChange}
                    />
                    <span>{t("addExerciseModal.overheadPress")}</span>
                  </label>

                  <label className={primary === "other" ? "active" : ""}>
                    <input
                      type="radio"
                      name="primary"
                      value="other"
                      checked={primary === "other"}
                      onChange={handleChange}
                    />
                    <span>{t("common:other")}</span>
                  </label>
                </div>
              </div>
            </div>
            <input
              type="text"
              name="newRepMax"
              id="newRMUnitInput"
              defaultValue={100}
              className="hidden"
            />
          </>
        )}

        <div className="form-row">
          <div className="form-row-item relative">
            <label>{t("addExerciseModal.exerciseName")}</label>
            <input
              tabIndex="0"
              type="text"
              placeholder={
                basicExerciseType === "basicExercise"
                  ? t("addExerciseModal.nameOfExercise")
                  : t("addExerciseModal.nameOfVariation")
              }
              {...movementName}
              maxLength="120"
              onChange={(e) => {
                handleNewMovementChange(e.target.value);
              }}
            />
            {basicExerciseType === "powerliftingExercise" &&
              primary !== "other" && (
                <span className="absolute right-4 bottom-4">
                  ({MOVEMENTS[primary] ?? capitalize(primary)})
                </span>
              )}
          </div>
        </div>

        {basicExerciseType === "powerliftingExercise" && (
          <ExtraInputComponent
            videoUrl={videoUrl}
            videoFile={videoFile}
            videoOriginal={videoOriginal}
            exerciseTypeField={exerciseTypeField}
            primaryMuscleGroup={primaryMuscleGroup}
            secondaryMuscleGroup={secondaryMuscleGroup}
            instructions={instructions}
            handleInputChange={handleNewFieldsInputChange}
            form="add-exercise-form"
          />
        )}

        {basicExerciseType === "basicExercise" && (
          <OtherExerciseFields
            parameters={parameters}
            freeFormSelected={freeFormSelected}
            updateOtherExerciseParameters={updateOtherExerciseParameters}
            videoFile={videoFile}
            videoOriginal={videoOriginal}
            videoUrl={videoUrl}
            instructions={instructions}
            handleInputChange={handleNewFieldsInputChange}
            exerciseTypeField={exerciseTypeField}
            primaryMuscleGroup={primaryMuscleGroup}
            secondaryMuscleGroup={secondaryMuscleGroup}
            intensityMeasure={intensityMeasure}
            isRiR={isRiR}
            form="add-exercise-form"
          />
        )}
      </div>

      <footer className="justify-end!">
        <button
          tabIndex="0"
          data-button-type="secondary"
          className="text-(--danger)!"
          onClick={(e) => {
            e.preventDefault();
            onDiscard();
          }}
        >
          {t("common:discard")}
        </button>

        <button
          tabIndex="0"
          data-button-type="primary"
          type="submit"
          form="add-exercise-form"
          disabled={isSecondaryDisabled}
        >
          {t("common:save")}
        </button>
      </footer>
    </>
  );
};

export default AddLibraryExercise;
